(function ($) {
    $(document).ready(function () {

        //************************************
        // Fixed header when scroll
        //************************************

        $(window).scroll(function () {
            if ($(window).scrollTop() >= 10) {
                $('header').addClass('fixed');
            } else $('header').removeClass('fixed');
        });

        //************************************
        // Menu desktop
        //************************************

        $('.desktop-menu > li.menu-item-has-children').hover(function () {
            $(this).find('.sub-menu').fadeIn(50);
            $('body').addClass('menu-open');
        }, function () {
            $(this).find('.sub-menu').fadeOut(50);
            $('body').removeClass('menu-open');
        });

        // Add Active Navigation Class Based on URL
        $(function () {
            if (window.location.pathname !== '/') {
                let pathArr = location.pathname.split('/').filter(Boolean);
                $('.yspl_win_widget_nav .column li a[href$="/' + pathArr[pathArr.length - 1] + '"]').addClass('active');
            }
        });

        // Add Active Class to Tab Based on click
        $(function () {
            if (window.location.pathname !== '/') {
                $('.yspl_win_widget_nav .nav-tabs a[data-toggle="tab"]').on('show.bs.tab', function (e) {
                    localStorage.setItem('activeTab', $(e.target).attr('href'));
                });
                let activeTab = localStorage.getItem('activeTab');
                if (activeTab) {
                    $('.yspl_win_widget_nav .nav-tabs a[href="' + activeTab + '"]').tab('show');
                }
            }
        });

        //************************************
        // main menu scroll to anchor on other page, and on the same page
        //************************************

        function menu_links_anchor_scroll_desktop() {

            let $header_height = $('.header').outerHeight();

            $('.navbar-nav .custom-html-widget .column li a').on('click', function (e) {

                $('.sub-menu').fadeOut('fast');
                let $this = $(this);
                let id;

                id = $this.attr('href').split("#")[1];

                $('html, body').animate({
                    scrollTop: $("#" + id).offset().top - $header_height
                }, 700);
            })
        }

        menu_links_anchor_scroll_desktop();

        function onload_page_scroll() {

            let $header_height = $('.header').outerHeight();

            let doc_location = document.location.href;
            if (doc_location.indexOf("#") + 1) {
                var location_section = doc_location.split('#')[1];
                if (location_section != 'results') {
                    $("html, body").animate({scrollTop: $("#" + location_section).offset().top - $header_height}, 700);
                }
            }
        }

        $(window).on('load', function () {
            onload_page_scroll();
        });

        //************************************
        // Menu mobile
        //************************************

        $('.lem-navbar-collapse').lemNav({
            collapse_duration: 0.6,
            navbar_collapse_duration: 0.2,
            navbar_animation: 'shift',
            trigger: 'click',
            navbar_toggle: '.lem-navbar-toggle'
        });

        $('.lem-navbar-toggle').click(function () {
            $('body').toggleClass('menu-open');
        });

        $('#menu-mobile-menu .sub-menu').on('shown.lnav', function (e) {
            const $subMenu = $(this);
            const $button = $subMenu.closest('li');
            const backButtonLabel = $button.find('>a').html();
            const $backButton = $('#menu-mobile-menu').find('.sub-menu-back-btn');
            $backButton.html(backButtonLabel);

            if ($button.hasClass('special-item')) {
                $backButton.addClass('special-style')
            } else {
                $backButton.removeClass('special-style')
            }

            e.stopPropagation();
            let $li = $(this).find('>li');
            TweenMax.to($li, 0.6, {'autoAlpha': 1})
        });

        $('#menu-mobile-menu .sub-menu').on('hide.lnav', function (e) {
            //e.stopPropagation();
            // let $li = $(this).find('>li');
            // $li.addClass('close');
            // TweenMax.to($li, 0.2, {'autoAlpha': 0})
        });

        $('.navbar-nav .sub-menu li a[href]').on('click', function () {
             $('.lem-navbar-collapse').lemNav('closeNavbar');
        })

        function menu_links_anchor_scroll_mobile() {

            $('.navbar-nav .sub-menu li a[href*="#"]').on('click', function () {
                $('body').removeClass('menu-open');
                let $this = $(this);
                let id;
                id = $this.attr('href').split("#")[1];

                if ($("#" + id).length > 0) {
                    $('html, body').animate({
                        scrollTop: $("#" + id).offset().top - 99
                    }, 700);
                }

            })
        }
        menu_links_anchor_scroll_mobile();
    });

})(jQuery);